import { ref } from 'vue';
import axios from 'axios';
import usePersistencyWithExpiry from '~/logic/composables/usePersistencyWithExpiry.js';
import { useAuthStore } from '~/logic/auth/auth-store';

export function useEnrichSummaryHttpCache () {

	const localStorageKeys = new Set([
		'enrichSummaryStore',
		'membershipStore',
	]);

	const getStorage = (keyName) => {
		return usePersistencyWithExpiry(keyName, {
			expiryDuration: 6.048e+8,
			autoRestore: true,
			autoWrite: false,
			refs: {},
		});
	};

	const {
		updateEnrichMembership,
		updateEnrichSummary,
	} = useAuthStore();

	const _updateMembershipSummaryAuth = (keyName, data) => {
		if (keyName === 'membershipStore') {
			updateEnrichMembership(data);
		}
		if (keyName === 'enrichSummaryStore') {
			updateEnrichSummary(data);
		}
	};

	const getRequest = async (keyName, apiUrl) => {

		try {
			const isKeyExists = localStorageKeys.has(keyName);

			const {
				retrieveLocalStorage,
				writeLocalStorage,
			} = getStorage(keyName);

			// check for any data cached against the keyname.
			if (isKeyExists) {
				const cachedData = retrieveLocalStorage();
				if (cachedData) {
					_updateMembershipSummaryAuth(keyName, cachedData);
					return cachedData;
				}
			}

			const res = await axios.get(apiUrl);
			const responseData = res?.data ?? null;

			// if data not exists and key present then cached the data
			if (isKeyExists && responseData) {
				_updateMembershipSummaryAuth(keyName, responseData);
				writeLocalStorage(responseData);
			}
			
			// if not then return data with cached.
			return responseData;
		} catch (err) {
			console.error('getRequest error:', err);
		} finally {
			// do nothing
		}
	};

	const clearCache = (keyName) => {
		const { deleteLocalStorage } = getStorage(keyName);
		deleteLocalStorage();
	};

	return {
		getRequest,
		clearCache,
	};
}